<template>
  <v-dialog scrollable content-class="custom-dialog" ref="dlgSertifikat" v-model="dialog" retain-focus max-width="700">
    <v-card>
      <v-img class="white--text align-end" height="200px" src="https://cdn.siap.id/s3/simpkb/asset%20img/DiklatGtk2023/bg-purple-gtk.jpg">
        <v-card-title class="display-1">Daftar Sertifikat</v-card-title>
      </v-img>
      <v-divider></v-divider>
      <v-card-text v-if="sertifikat && sertifikat.length == 0" class="pt-6">
        <v-row justify="center">
          <v-col cols="12" align="center">
            <p class="pa-4 subtitle-1 black--text">
              Bagi peserta yang dinyatakan lulus, Sertifikat
              <strong>Bimbingan Teknis Literasi Tahun 2025</strong> telah tersedia.
              Silakan cek dan unduh sertifikat Anda melalui tombol di bawah ini.
            </p>

            <v-btn
              color="primary"
              large
              class="white--text"
              href="https://sindara.gurudikdas.kemendikdasmen.go.id/presensi/sertifikat/"
              target="_blank"
              rel="noopener"
            >
              Unduh Sertifikat
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-text>
        <v-card outlined class="elevation-0 mt-5" v-for="item in sertifikat" :key="item.id">
          <v-card-text class="my-1 py-0">
            <v-row>
              <v-col cols="12" sm="12" md="12" lg="12" class="mb-0 pb-0 mt-2">
                <span class="font-weight-bold black--text">{{ pVal(item, "nama_kelas") }}</span>
              </v-col>
              <v-col cols="12" sm="12" md="8" lg="8" v-if="item.is_rilis">
                <template v-if="item.link_survey">
                  <p class="black--text my-0 py-0" v-if="item.is_survey">
                    {{ pVal(item.data_sertif.m_sertifikat_gurubelajar, "kegiatan") }}
                  </p>
                  <p v-else class="black--text">
                    Tautan unduhan Sertifikat/Piagam Anda akan muncul setelah Anda menyelesaikan kuesioner {{ item.kelas_id == 0 ? "di atas" : "berikut" }}
                  </p>
                </template>
                <p class="black--text my-0 py-0" v-else>{{ pVal(item.data_sertif.m_sertifikat_gurubelajar, "kegiatan") }}</p>
              </v-col>
              <v-col cols="12" sm="12" md="12" lg="12" v-if="item.is_rilis && item.kelas_id != 0">
                <m-button
                  v-if="item.link_survey && item.is_survey == false"
                  icon="mdi-format-list-checks"
                  color="info"
                  textButton="kuesioner "
                  action="toKuesioner"
                  @toKuesioner="toKuesioner(item.link_survey)"
                ></m-button>
                <m-button
                  v-else-if="item.data_sertif.length == 0 || !item.data_sertif.url_unduh"
                  icon="mdi-refresh"
                  depressed
                  color="orange white--text"
                  textButton="Dalam Proses"
                  action="toReload"
                  @toReload="load()"
                ></m-button>
                <m-button v-else outlined icon="mdi-download" depressed textButton="Unduh" action="toCourse" @toCourse="toCourse(item.data_sertif)"></m-button>
                <m-button
                  v-if="current_user.is_super_admin"
                  class="ma-3"
                  outlined
                  icon="mdi-refresh"
                  color="amber"
                  depressed
                  textButton="Proses Ulang"
                  action="toCourse"
                  @toCourse="toRegen(item.data_sertif)"
                ></m-button>
              </v-col>
              <v-col cols="12" sm="12" md="4" lg="4" v-if="item.is_rilis && item.kelas_id == 0">
                <p v-for="sertifikat in item.data_sertif.data" :key="sertifikat.index">
                  {{ sertifikat.nama }} <br />
                  <m-button
                    :disabled="item.is_survey ? false : true"
                    outlined
                    icon="mdi-download"
                    depressed
                    textButton="Unduh"
                    action="toCourse"
                    @toCourse="toCourse(sertifikat)"
                  ></m-button>
                </p>
              </v-col>
              <v-col cols="12" sm="12" md="12" lg="12" v-if="!item.is_rilis">
                <p class="primary--text"></p>
                <m-alert
                  show
                  :info="
                    item.is_piagam
                      ? `Piagam akan diterbitkan pada hari ` +
                        $tools.toDT(item.tanggal_rilis) +
                        `.<p class='my-2'> ${
                          !current_user.komunitas_id
                            ? 'Silahkan bergabung ke <strong>komunitas yang tersedia</strong> <a target=\'_blank\' href=' +
                              $consts.SIMPKB +
                              '>Bergabung Komunitas</a> terlebih dahulu untuk dapat mengakses sertifikat Anda</p>'
                            : ''
                        }`
                      : item.tanggal_rilis
                      ? `Sertifikat akan diterbitkan pada hari ` + $tools.toDT(item.tanggal_rilis)
                      : 'Sertifikat Anda akan segera diterbitkan'
                  "
                ></m-alert>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <v-card outlined class="elevation-0 mt-5" v-for="piagam in piagam" :key="piagam.id">
          <v-card-text class="my-1 py-0">
            <v-row>
              <v-col cols="12" sm="12" md="12" lg="12" class="mb-0 pb-0">
                <span class="font-weight-bold black--text">{{ pVal(piagam, "nama") }}</span>
              </v-col>
              <v-col cols="12" sm="12" md="8" lg="8" v-if="piagam.is_rilis">
                <div v-if="!piagam.is_syarat_done" class="black--text">
                  Tautan unduhan Piagam Anda akan muncul setelah Anda menyelesaikan syarat berikut
                  <ol>
                    <li v-for="syarat in piagam.keterangan_syarat" :key="syarat.index">
                      {{ syarat }}
                    </li>
                  </ol>
                </div>
                <div v-else>
                  <span v-if="piagam.link_survey">Tautan unduhan Sertifikat/Piagam Anda akan muncul setelah Anda menyelesaikan kuesioner berikut</span>
                </div>
              </v-col>
              <v-col cols="12" sm="12" md="12" lg="12" v-if="!piagam.is_rilis">
                <p class="primary--text"></p>
                <m-alert v-if="piagam.tanggal_rilis" show :info="`Piagam akan diterbitkan pada hari ` + $tools.toDT(piagam.tanggal_rilis)"></m-alert>
                <m-alert v-else show info="Piagam Anda akan segera diterbitkan"></m-alert>
              </v-col>
              <v-col cols="12" sm="12" md="4" lg="4" v-if="piagam.is_rilis && piagam.is_syarat_done">
                <!--jika mensyaratkan survey-->
                <template v-if="piagam.link_survey">
                  <div v-if="piagam.is_survey" class="black--text">
                    <m-button
                      v-if="piagam.data_piagam.length == 0 || !piagam.data_piagam[0].url_unduh"
                      icon="mdi-refresh"
                      depressed
                      color="orange white--text"
                      textButton="Dalam Proses"
                      action="toReload"
                      @toReload="loadPiagam()"
                    ></m-button>
                    <m-button v-else outlined icon="mdi-download" depressed textButton="Unduh" action="toCourse" @toCourse="toUnduhPiagam(piagam.data_piagam[0])"></m-button>
                  </div>
                  <div v-if="!piagam.is_survey" class="black--text">
                    <m-button icon="mdi-format-list-checks" color="info" textButton="kuesioner " action="toKuesioner" @toKuesioner="toKuesioner(piagam.link_survey)"></m-button>
                  </div>
                </template>
                <!--                jika tidak mensyaratkan survey-->
                <template v-else>
                  <m-button
                    v-if="piagam.data_piagam.length == 0 || !piagam.data_piagam[0].url_unduh"
                    icon="mdi-refresh"
                    depressed
                    color="orange white--text"
                    textButton="Dalam Proses"
                    action="toReload"
                    @toReload="loadPiagam()"
                  ></m-button>
                  <m-button v-else outlined icon="mdi-download" depressed textButton="Unduh" action="toCourse" @toCourse="toUnduhPiagam(piagam.data_piagam[0])"></m-button>
                </template>
              </v-col>

              <v-col cols="12" sm="12" md="12" lg="12" v-if="!piagam.is_rilis">
                <p class="primary--text"></p>
                <m-alert v-if="piagam.tanggal_rilis" show :info="`Piagam akan diterbitkan pada hari ` + $tools.toDT(piagam.tanggal_rilis)"></m-alert>
                <m-alert v-else show info="Piagam Anda akan segera diterbitkan"></m-alert>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-card-text>
      <v-card-actions class="pb-4">
        <v-spacer></v-spacer>
        <m-button
          color="grey"
          outlined
          class="mx-4"
          :small="$vuetify.breakpoint.smAndDown ? true : false"
          textButton="Tutup"
          icon="mdi-close"
          action="tutup"
          @tutup="dialog = false"
        ></m-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { PASSPORT } from "@/const";
export default {
  components: {},
  data() {
    return {
      sertifikat: null,
      infoRelease: "",
      dialog: false,
      resolve: null,
      reject: null,
      showInfo: false,
      piagam: null,
      id_seri: null,
      user: null
    };
  },
  methods: {
    // eslint-disable-next-line
    open(show, id_seri, user) {
      this.id_seri = id_seri ? id_seri : this.instansi_id;
      this.showInfo = show;
      this.user = user;
      return this.load(this.user).then(() => {
        return new Promise((resolve, reject) => {
          this.resolve = resolve;
          this.reject = reject;
          this.dialog = true;
        });
      });
    },
    // eslint-disable-next-line
    load(user) {
      return this.$store
        .dispatch("user/getSertifikat", { instansi_id: this.id_seri, params: { user_id_from_mobile: user ? user.user_id : null } })
        .then(res => {
          this.sertifikat = res;
          this.loadPiagam(user);
        })
        .catch(e => e);
    },
    loadPiagam(user) {
      return this.$store
        .dispatch("user/getPiagam", { instansi_id: this.id_seri, params: { user_id_from_mobile: user ? user.user_id : null } })
        .then(res => {
          this.piagam = res;
        })
        .catch(e => e);
    },

    // eslint-disable-next-line
    // method untuk unduh piagam
    // @args objek piagam
    toUnduhPiagam(val) {
      this.loading = true;
      return this.$store
        .dispatch("user/cetakPiagam", val.url_unduh)
        .then(res => {
          if (res) {
            this.loading = false;
            this.$info("Proses Cetak Piagam berhasil.");
          }
        })
        .catch(() => {
          this.loading = false;
          this.$error("Proses Cetak Piagam gagal.");
        });
    },

    // eslint-disable-next-line
    toCourse(val) {
      this.loading = true;
      return this.$store
        .dispatch("user/cetakSertifikat", val.url_unduh)
        .then(res => {
          if (res) {
            this.loading = false;
            this.$info("Proses Cetak Sertifikat berhasil.");
          }
        })
        .catch(() => {
          this.loading = false;
          this.$error("Proses Cetak Sertifikat gagal.");
        });
    },
    toRegen(val) {
      this.loading = true;
      return this.$store
        .dispatch("user/regenSertifikatPiagam", { instansi_id: this.id_seri, nomor_sertifikat: val.nomor })
        .then(res => {
          if (res) {
            this.loading = false;
            this.load(this.user);
            this.$info("Proses Regenerate berhasil, silakan unduh ulang.");
          }
        })
        .catch(() => {
          this.loading = false;
          this.$error("Proses Regenerate gagal.");
        });
    },
    toKuesioner(val) {
      window.open(PASSPORT + val, "_blank");
    }
  },
  watch: {
    dialog(n) {
      if (!n && this.reject) {
        this.reject(null);
      }
    }
  },
  computed: {}
};
</script>
